<template>
  <div id="app" :style="nowStyle">
    <img id="uploadImg" alt="" src=""> <!-- 用于数据上报 避免跨域 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>
<script>
import DataStore from 'utils/dataStore';
import Env from 'utils/env';
import { setUserInfo } from 'utils/user';
import { initBaiduMonitor } from 'utils/uploadData';
import MgStat from 'MgStat';

export default {
  data() {
    return {
      nowStyle: '',
    };
  },
  created() {
    initBaiduMonitor();
    setUserInfo();
    document.title = '芒果好物';
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  },
  watch: {
    /* 记录路由变化 */
    $route(val, oldVal) {
      const { isWeixin } = Env;
      if (isWeixin) {
        const { location: { href } } = window;
        /* const arr = [singlemessage', 'timeline', 'groupmessage']; */
        if (href.indexOf('html?') !== -1) { // 微信会直接在.html后面自动拼接参数
          const allLen = href.length;
          const start = href.indexOf('?');
          const end = href.indexOf('#');
          const str1 = href.substring(0, start);
          const str2 = href.substring(end, allLen);
          window.location.replace(str1 + str2);
        }
      }
      DataStore.setNowPage(val.name);
      DataStore.setPrePage(oldVal.name);
      if (val.name === 'home' || val.name === 'share_coupon' || val.name === 'homeTest' || val.name === 'cfDet' || val.name === 'linkCoupon') {
        this.nowStyle = 'padding:0';
      } else if ((val.name !== 'cart') && (Env.isWeixin || Env.isWeiBo || Env.isQQ || Env.isMgtvApp)) { // APP内去掉导航栏
        this.nowStyle = 'padding:0';
      } else {
        this.nowStyle = '';
      }

      // 以下是PV数据上报
      document.getElementsByTagName('html')[0].setAttribute('mg-stat-page', `haowu_${val.name}`);
      document.getElementsByTagName('html')[0].setAttribute('mg-stat-autoshow', true);
      if (val.name !== 'goods_detail' && val.name !== 'iframe' && val.name !== 'cfDet' && val.name !== 'cfPay' && val.name !== 'memberSuccess') {
        // iframe不上报、goods_detail单独定制上报  cfDet 众筹需要单独上报、cfPay 没有复用支付，需要单独上报
        if (val.name !== 'pay') {
          const goods_id = val.name === 'goods_detail' && val.query.id ? val.query.id : '';
          const sp_id = val.name === 'topic' && val.query.id ? val.query.id : '';
          MgStat.send('pv', { goods_id, sp_id }, { cntp: `haowu_${val.name}` });
        } else {
          MgStat.send('pv', {}, { cntp: `haowu_${val.name}` });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
  padding-top: 86px;
  box-sizing: border-box;
  @media screen and (min-width: 1025px) {
    max-width: 500px; /*no*/
    margin: 0 auto;
  }
}

#uploadImg {
  display: none;
}
</style>
